<template>
  <div class="content">
    <card class="card">
      <div class="row">
        <div class="col-sm-3">
          <div class="row">
            <label class="col-sm-4 col-form-label">작성자</label>
            <div class="col-sm-8">
              <el-select class="select-primary" size="large" placeholder="작성자" v-model="userId">
                <el-option v-for="option in authorOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
              </el-select>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <base-input placeholder="설명">
            <textarea class="form-control" rows="30" v-model="comment" />
          </base-input>
        </div>
        <div class="col-sm-3">
          <button @click.prevent="onClickAdd()" class="btn btn-sm btn-round btn-success">댓글 등록</button>
        </div>
      </div>
    </card>
    <card type="timeline" class="card-plain">
      <time-line type="simple">
        <time-line-item v-for="comment in comments" v-bind:key="comment.id" inverted badge-type="">
          <div slot="icon">
            <img
              v-if="!comment.profileImageFileId"
              style="width: 100%; height: 100%; border-radius: 50%; margin-bottom: 3px"
              src="@/assets/img/no_profile.png"
            />
            <img
              v-if="!!comment.profileImageFileId"
              style="width: 100%; height: 100%; border-radius: 50%; margin-bottom: 3px"
              :src="comment.profileImageFileId | imageUrlWithFileId"
            />
          </div>

          <div class="header" slot="header">
            <span class="badge badge-danger">{{ comment.nickname }}</span>
            <span>{{ comment.regTime | formatDateTime }}</span>
            <span>{{ comment.state | commentStateName }}</span>
            <button v-if="comment.state === 1" @click.prevent="onClickDelete(comment.id)" class="btn btn-sm btn-round btn-danger">삭제</button>
            <button v-if="comment.state === 12" @click.prevent="onClickRestore(comment.id)" class="btn btn-sm btn-round btn-success">복구</button>
            <button
              v-if="comment.state === 1 && !comment.parentId"
              @click.prevent="onClickAdd(comment.id, comment.userId)"
              class="btn btn-sm btn-round btn-success"
            >
              대댓글등록
            </button>
          </div>

          <template slot="content">
            <span>{{ comment.comment }}</span>
          </template>
        </time-line-item>
      </time-line>
    </card>
  </div>
</template>

<script>
import { Toast } from "@/util/Toast";
import { showAPIErrorToast } from "../../util/ErrorUtils";
import { URLUtils } from "@/util/URLUtils";
import * as _ from "lodash";
import TimeLine from "@/components/Timeline/TimeLine";
import TimeLineItem from "@/components/Timeline/TimeLineItem";
import { BaseInput, Card } from "@/components/index";
import { Alert } from "@/util/Alert";
export default {
  name: "ContentCommentsPage",
  components: {
    Card,
    BaseInput,
    TimeLine,
    TimeLineItem,
  },
  async created() {
    if (_.isEmpty(this.$route.query)) {
      await this.$router.back();
      return;
    }

    const { namespace, unitId, contentId } = this.$route.query;
    if (!namespace || !unitId || !contentId) {
      await this.$router.back();
    }
    await this.getDummyAuthors(unitId);
    this.fetchComments();
  },
  data() {
    return {
      userId: null,
      comment: null,
      authorOptions: [],
      comments: [],
    };
  },
  methods: {
    async getDummyAuthors(unitId) {
      try {
        const dummyUsers = await this.$axios.get(`/artistUnit/${unitId}/dummyUsers`);
        const contentAdmins = await this.$axios.get(`/artistUnit/${unitId}/contentAdmins`);

        this.dummyAuthors = dummyUsers.data.data.users.concat(contentAdmins.data.data.users);

        this.authorOptions = [
          ...this.dummyAuthors
            .filter((author) => author.id !== this.userId)
            .map((author) => ({
              label: `${author.nickname}(${author.id})`,
              value: author.id,
            })),
        ];
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async fetchComments() {
      const { namespace, unitId, contentId } = this.$route.query;

      const queryParams = {
        namespace: parseInt(namespace, 10),
        unitId: parseInt(unitId, 10),
        contentId: parseInt(contentId, 10),
        page: 1,
        pageSize: 5000,
      };

      try {
        const result = await this.$axios.get(`/comments?${URLUtils.objectToQueryString(queryParams)}`);
        this.comments = result.data.data;
      } catch (err) {
        showAPIErrorToast(err);
      }
    },
    async onClickDelete(commentId) {
      if (await Alert.dangerousConfirmCancel("댓글을 삭제하시겠습니까?", "댓글 작성자에게 알림 없이 삭제됩니다.")) {
        const queryParams = {
          namespace: parseInt(this.$route.query.namespace, 10),
          commentId,
        };

        try {
          const result = await this.$axios.delete(`/comments?${URLUtils.objectToQueryString(queryParams)}`);
          Toast.success(result.data.data.message);

          this.fetchComments();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async onClickRestore(commentId) {
      if (await Alert.dangerousConfirmCancel("댓글을 복원하시겠습니까?", "댓글 작성자에게 알림 없이 복원됩니다.")) {
        const bodyParams = {
          namespace: parseInt(this.$route.query.namespace, 10),
          commentId,
        };

        try {
          const result = await this.$axios.put(`/comments/restore`, bodyParams);
          Toast.success(result.data.data.message);

          this.fetchComments();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
    async onClickAdd(parentId, parentUserId) {
      let title = "댓글을 등록하시겠습니까?";
      if (parentId) {
        title = "대댓글을 등록하시겠습니까?";
      }
      if (!this.userId) {
        Toast.error("작성자를 선택해주세요");
        return;
      }
      if (!this.comment) {
        Toast.error("댓글을 입력해주세요");
        return;
      }
      const { namespace, unitId, contentId } = this.$route.query;
      if (await Alert.dangerousConfirmCancel(title)) {
        const bodyParams = {
          namespace: parseInt(namespace, 10),
          unitId: parseInt(unitId, 10),
          contentId: parseInt(contentId, 10),
          userId: this.userId,
          comment: this.comment,
        };
        if (parentId) {
          bodyParams.parentId = parseInt(parentId, 10);
          bodyParams.parentUserId = parentUserId;
        }

        try {
          const result = await this.$axios.post(`/comments`, bodyParams);
          Toast.success(result.data.data.message);
          this.comment = null;
          this.fetchComments();
        } catch (err) {
          showAPIErrorToast(err);
        }
      }
    },
  },
};
</script>
<style scoped lang="scss">
.row {
  margin-bottom: 10px;
}

.header {
  span {
    margin-right: 20px;
  }
}
</style>
